const initialState = {
  parkPosts: [],
  loading: true,
  parks: [],
  posts: [],
  categories: [],
  features: [],
  addresses: [],
  signedInUser: null,
  jwt: null
}

export default initialState;